var _excluded = ["rows", "withHeader"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Table as CoreTable, Td, Th, Tr } from '@kizi/core-components';
import * as React from 'react';
export var Table = function Table(_ref) {
  var rows = _ref.rows,
      _ref$withHeader = _ref.withHeader,
      withHeader = _ref$withHeader === void 0 ? true : _ref$withHeader,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(CoreTable, restProps, /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row, j) {
    return /*#__PURE__*/React.createElement(Tr, {
      key: "row-".concat(j)
    }, row.map(function (cell, k) {
      var Cell = function Cell(props) {
        return j === 0 && withHeader ? /*#__PURE__*/React.createElement(Th, props) : /*#__PURE__*/React.createElement(Td, props);
      };

      return /*#__PURE__*/React.createElement(Cell, {
        key: "cell-".concat(j, "-").concat(k)
      }, cell);
    }));
  })));
};